import React from 'react'
import green_tick from '../../../assets/section_new_images/exploremore/green_tick.png'

const WhatyouWillLearn = ({ whatYouWillLearn }) => {
    return (
        <div className='mb-3 mb-md-5  w-100' style={{ backgroundColor: '#F5F5FF' }}>
            <div className="container py-3 py-md-5 px-2 d-flex flex-column align-items-center">
                <div className="headerText text-center">What you will learn</div>
                <div className='d-flex flex-column align-items-start pt-3 pt-md-5' style={{gap: 'clamp(1rem, 2.5vw, 2rem)'}}>
                    {whatYouWillLearn.map((item, index) => (
                        <div key={index} className='d-flex align-items-start px-3 what_will_you_learn' style={{gap: 'clamp(0.5rem, 1.5vw, 1rem)'}}>
                            <img src={green_tick} alt='tick' />
                            <span style={{ color: '#8F8E8E', font: '400 clamp(1rem, 2.5vw, 2rem)/normal Nunito' }}>{item}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default WhatyouWillLearn